module.exports = __webpack_public_path__ + "static/img/67.fe1fca5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/67.gif
// module id = pNce
// module chunks = 0